import { render } from "./JobItemDescription.vue?vue&type=template&id=49569455"
import script from "./JobItemDescription.vue?vue&type=script&lang=js"
export * from "./JobItemDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__